import { Navigate, Route, Routes } from 'react-router-dom';
import Landing from './Landing';
import AdminLogin from './admin/AdminLogin';
import AdsEditor from './admin/AdsEditor';
import RequireAdmin from './admin/RequireAdmin';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <AdsEditor />
          </RequireAdmin>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
